import { Component } from '@angular/core';

@Component({
    selector: 'not-found',
    templateUrl: 'not-found.template.html'
})
export class notFoundComponent {}


// WEBPACK FOOTER //
// ./src/app/components/common/layouts/not-found.component.ts